/**
 * The referral status vocabulary, in a module that imports nothing.
 *
 * The sibling of `offer-vocabulary.ts`, extracted for the same reason and
 * measured the same way: `router.tsx` imports every route's `validateSearch`
 * schema EAGERLY, and `referrals.route.search.ts` validating its status filter
 * out of `schemas/referral.schema.ts` put every referral wire row and both
 * dialog form schemas into the initial chunk.
 *
 * The tuple is the single source of truth: `referral.schema.ts` re-derives its
 * Zod enum from it, so the URL parser and the wire parser cannot drift.
 */

/// The four the shore's referral status vocabulary names, in its order.
export const REFERRAL_STATUSES = ["pending", "in_process", "accepted", "rejected"] as const;
export type ReferralStatusName = (typeof REFERRAL_STATUSES)[number];
